import {
    getFaqList,
    getFaq,
} from "../apis/api_faq.js";

import { listMode } from '../utils/table';

const state = {
    filters: { mode: listMode.list, typeList: [], dtype: ''},
    items: [],
    item: {},   
};

const getters = {
};

const mutations = {
    SET_FAQ_LIST(state, items){
        state.items = items;
    },

    SET_FAQ(state, payload) {
        state.item = payload
    },

    CLEAR_FAQ(state) {
        state.item = {};
    },
};

const actions = {

    async GET_FAQ_LIST({ state, commit }, filters ) {
        let params = { ...state.filters, ...filters };
        try {
            const response = await getFaqList(params);
            commit('SET_FAQ_LIST', response.data.data.content)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_FAQ({ commit }, id) {
        try {
            const response = await getFaq(id);
            commit('SET_FAQ', response.data.data)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },    
};

export default {mutations, state, actions, getters};